const STORAGE_KEY = 'viewedProducts';
const MAX_STORED = 8;

export class RecentlyViewed {
  static get storageKey() {
    return STORAGE_KEY;
  }

  /** @param {string} productId */
  static get storageKey() {
    return STORAGE_KEY;
  }

  /** @param {string} productId */
  static addProduct(productId) {
    let list = this.getProducts().filter((id) => id !== productId);
    list.unshift(productId);
    list = list.slice(0, MAX_STORED);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  static clearProducts() {
    localStorage.removeItem(STORAGE_KEY);
  }

  /** @returns {string[]} */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }
}
